export const EASE_OUT = [0.16, 1, 0.3, 1] as const;
export const EASE_IN_OUT = [0.65, 0, 0.35, 1] as const;

export const springSnappy = {
  type: "spring" as const,
  stiffness: 500,
  damping: 35,
  mass: 0.8,
};

export const springSoft = {
  type: "spring" as const,
  stiffness: 260,
  damping: 28,
};

export const springCursor = {
  type: "spring" as const,
  stiffness: 180,
  damping: 22,
  mass: 0.6,
};

export const stagger = {
  fast: 0.04,
  normal: 0.08,
  slow: 0.12,
};

export const fadeUp = {
  hidden: { opacity: 0, y: 24, filter: "blur(6px)" },
  visible: { opacity: 1, y: 0, filter: "blur(0px)" },
};

export const fadeUpTransition = (delay = 0) => ({
  duration: 0.7,
  ease: EASE_OUT,
  delay,
});
